<template>
  <div class="calico-loan-beacon-indicator-page">
    <div class="container">
      <CalicoLoanBeaconIndicator
        :value="true"
        @toggle="onToggle"
      />
    </div>
  </div>
</template>

<script>
import CalicoLoanBeaconIndicator from '@/components/calico/loanBeaconIndicator/index.vue';

export default {
  name: 'CalicoLoanBeaconIndicatorPage',
  components: {
    CalicoLoanBeaconIndicator,
  },
  methods: {
    onToggle (value) {
        console.log("toggled!", value)
    }
  }
};
</script>

<style lang="scss">
.calico-loan-beacon-indicator-page {
  .container {
    @include stack-space($space-large);
    @include inset-space($space-large);
  }
}
</style>
